import { X } from '@phosphor-icons/react';
import './search-clear-button.css';

export function SearchClearButton({ label, disabled = false, onClear }: {
  label: string;
  disabled?: boolean;
  onClear: () => void;
}) {
  return <button type="button" className="search-clear-button" aria-label={label} title={label}
    disabled={disabled} onClick={onClear}><X weight="bold" aria-hidden="true" /></button>;
}
